import { CustomComponentProps } from "utils/types/generalTypes";
import SVG from "../core/SVG";
import CustomVideoPlayer from "../core/CustomVideoPlayer";

export type FormVideoViewerProps = CustomComponentProps & {
    video: File;
    handleRemoveMedia: () => void;
};

const FormVideoViewer = ({
    video,
    handleRemoveMedia,
    className,
    style
}: FormVideoViewerProps) => {
    return (
        <div
            className={`vid-displayer post-media-displayer p-relative pt-10 pb-10 ${className}`}
            style={style}
        >
            <CustomVideoPlayer src={URL.createObjectURL(video)} />
            <div className="close-wrap">
                <span
                    className="custom-close-modal"
                    onClick={handleRemoveMedia}
                >
                    <SVG svg="x" size={16} />
                </span>
            </div>
        </div>
    );
};

export default FormVideoViewer;
